/** Mensajes benignos del navegador / pdf.js que no deben romper el overlay de webpack-dev-server. */
const IGNORED_RUNTIME_ERROR_MESSAGES = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
    "Cannot read properties of null (reading 'destroy')",
    "Cannot access 'firstPagePromise' before initialization",
    "Cannot read properties of undefined (reading 'promise')",
    "Cannot read properties of undefined (reading 'dispatch')",
    // React vs pdf.js: el webcomponent destruye nodos que React aún intenta desmontar (portales/overlay).
    "Failed to execute 'removeChild' on 'Node'",
    'The node to be removed is not a child of this node'
];

let isRegistered = false;

function getRuntimeErrorMessage(event: Event): string | undefined {
    if (event instanceof ErrorEvent) {
        return event.message;
    }
    if (event instanceof PromiseRejectionEvent) {
        const reason = event.reason;
        return typeof reason === 'string' ? reason : reason?.message;
    }
    return undefined;
}

export function isIgnoredRuntimeErrorMessage(message: string | undefined): boolean {
    return Boolean(message && IGNORED_RUNTIME_ERROR_MESSAGES.some((ignored) => message.includes(ignored)));
}

/** Registra listeners tempranos para que el overlay de webpack no muestre estos errores. */
export function suppressBenignRuntimeErrors(): void {
    if (isRegistered || typeof window === 'undefined') return;
    isRegistered = true;

    const suppress = (event: Event) => {
        if (!isIgnoredRuntimeErrorMessage(getRuntimeErrorMessage(event))) return;
        event.stopImmediatePropagation();
        event.preventDefault();
        document.getElementById('webpack-dev-server-client-overlay')?.setAttribute('style', 'display: none');
        document.getElementById('webpack-dev-server-client-overlay-div')?.setAttribute('style', 'display: none');
    };

    window.addEventListener('error', suppress, true);
    window.addEventListener('unhandledrejection', suppress, true);
}
